import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./PortfolioAlbumView.css";
import {
  GetProfile,
  getAPIUrl,
  getLoginPage,
  getQueryVariable,
  globalLoader,
  get_logo,
  catchError
} from "../../script/util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faShareNodes,
  faCopy,
  faPause,
  faArrowLeft,
  faArrowRight,
  faAngleRight,
  faEllipsis,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import axios from "axios";
import Pageflip from "../Pageflip";
import Popup from "../Popup/Popup";
import { Link, useNavigate } from "react-router-dom";
import copy from "clipboard-copy";


const PortfolioAlbumView = () => {
  const [albumData, setAlbumData] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [shareUrl, setShareUrl] = useState();
  const [linkCopied, setLinkCopied] = useState(false);
  const rect = useRef();
  const goFull = useRef(false);
  const divRef = useRef(null);
  const [divHeight, setDivHeight] = useState();
  const [rotate, setRotate] = useState(false);
  const [bookingPK, setBookingPK] = useState()
  const [isOpen, setIsOpen] = useState(true);
  const id = useRef();
  const playRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    id.current = queryParams.get("work_id");
    if (id.current === null) {
      navigate("/");
    }
    id &&
      axios({
        method: "get",
        url: getAPIUrl(`/api/work/portfolio/${id.current}/`),
        headers: {},
        dataType: "json",
        cache: false,
      })
        .then(function (res) {
          const tp = res.data;
          if (tp.success) {
            setAlbumData(tp);
            setBookingPK(tp.booking_pk)
          }
        })
        .catch((error) => {
          catchError(error);
        });
  }, []);
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setIsPlaying(false);
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);
  const updateDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    setDivHeight(height);
    if (width + 100 < height) {
      setRotate(true);
    } else {
      setRotate(false);
    }
  };
  useEffect(() => {
    if (!document.webkitIsFullScreen) {
      setIsPlaying(false);
    }
  }, [document.webkitIsFullScreen]);

  useEffect(() => {
    updateDimensions();

    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);
  
  const headers = {};
  const inputData = { data_id_list: [`${id.current}`] };
  const ShareCall = () => {
    setIsPopupOpen(true);
    axios
      .post(getAPIUrl(`/api/share/url/${bookingPK}/`), inputData, { headers })
      .then(function (res) {
        console.log(res);
        setShareUrl(res.data.share_url);
      })
      .catch((error) => {
        catchError(error)
      });
  };

  const copyLinkUrl = () => {
    setLinkCopied(true);
    copy(shareUrl);
    setTimeout(() => {
      setLinkCopied(false);
    }, 2000);
  };

  if (isPlaying) {
    if(!(document.documentElement.mozRequestFullScreen)){
      document.documentElement.webkitRequestFullscreen();
    }else{
      document.documentElement.mozRequestFullScreen()
    }
    goFull.current = true;
  } else {
    if (goFull.current) {
      document.exitFullscreen();
      goFull.current = false;
    }
  }

  return (
    <>
      {albumData ? (
        <>
          <div
            ref={divRef}
            className="album_mainDiv"
          >
            {!rotate ? (
              <>
                <div className="navDiv">
                  <div>
                    <img
                      className="logoWidth"
                      src={get_logo()}
                    />
                  </div>
                  {divHeight > 600 && (
                    <div style={{ textAlign: "center" }}>
                      <div style={{ color: "white", fontWeight: "900" }}>
                        {albumData.title}
                      </div>
                      <div style={{ color: "white", fontSize: "0.8rem" }}>
                        {albumData.subtitle}
                      </div>
                    </div>
                  )}
                  <div style={{ display: "flex" }}>
                    <div
                      className="playButtonClass"
                      style={{ margin: "0 0.8rem" }}
                      ref={playRef}
                    >
                      <FontAwesomeIcon
                        onClick={() => {
                          setIsPlaying((prev) => !prev);
                          goFull.current = `${isPlaying}`;
                        }}
                        icon={isPlaying ? faPause : faPlay}
                        size="xl"
                        style={{ color: "#ffffff" }}
                        ref={playRef}
                      />
                    </div>
                  </div>
                </div>
                <div className="outerFlipDiv" onLoad={updateDimensions}>
                  <FontAwesomeIcon
                    className="leftFlip"
                    icon={faAngleRight}
                    flip="horizontal"
                    size="2xl"
                    style={{ color: "#ffffff", cursor: "pointer" }}
                    onClick={updateDimensions}
                  />
                  <Pageflip
                    albumData={albumData}
                    play={isPlaying}
                    rect={rect}
                    rotate={rotate}
                  />
                  <FontAwesomeIcon
                    className="rightFlip"
                    icon={faAngleRight}
                    size="2xl"
                    style={{ color: "#ffffff", cursor: "pointer" }}
                  />
                </div>
                {divHeight > 600 && (
                  <div className="instructions">
                    <div
                      style={{
                        maxWidth: "max-content",
                        backgroundColor: "rgba(255,255,255,0.1",
                        marginBottom: "1rem",
                        padding: "0.7rem 1rem",
                        borderRadius: "1rem",
                        fontSize: "initial",
                      }}
                    >
                      Use the arrows({" "}
                      <FontAwesomeIcon
                        icon={faArrowLeft}
                        style={{ color: "#ffffff" }}
                      />{" "}
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "#ffffff" }}
                      />{" "}
                      )to navigate
                    </div>
                  </div>
                )}
                {linkCopied && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "1rem",
                      borderRadius: "0.5rem",
                      right: "1rem",
                      padding: "0.3rem 1.5rem",
                      zIndex: "1000",
                      backgroundColor: "rgba(255,255,255,0.1",
                    }}
                  >
                    <div
                      id="liveToast"
                      className="toast hide"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                    >
                      <div className="toast-body" style={{ color: "white" }}>
                        Link Copied
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div
                style={{
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "inherit",
                  padding: "1rem",
                  textAlign: "center",
                }}
              >
                Rotate your phone to landscape mode to view your album.
              </div>
            )}
          </div>
          <div
            className={`playButtonClass transition ${
              isOpen ? "playTrans" : ""
            }`}
            ref={playRef}
          >
            <FontAwesomeIcon
              onClick={() => {
                setIsPlaying((prev) => !prev);
                goFull.current = `${isPlaying}`;
              }}
              icon={isPlaying ? faPause : faPlay}
              size="lg"
              style={{ color: "#ffffff" }}
              ref={playRef}
            />
          </div>
        </>
      ) : (
        <div className="fullpage-overlay">{globalLoader()}</div>
      )}
    </>
  );
};

export default PortfolioAlbumView;
